module.exports = __webpack_public_path__ + "static/img/cw-4.1a0d03d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/cw-4.jpg
 ** module id = 578
 ** module chunks = 2
 **/